<template>
  <div class="animated fadeIn">
    <component-header
      title="Create Q&A"
      :hasback="true"
      :hasCreate="false"
      :hasSearch="false"
      :hasReload="false"
      @back-press="$router.push('/survey')"
    />
    <ValidationObserver ref="observer">
      <b-card>
        <b-form @submit.prevent="handleSubmit">
          <b-row
            ><b-col>
              <b-form-group label="Survey Title" label-for="survey-title">
                <b-form-input
                  id="survey-title"
                  v-model="survey.title"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Survey Description" label-for="survey-description">
                <b-form-textarea
                  id="survey-description"
                  v-model="survey.description"
                  rows="3"
                  required
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="1">
              <b-button variant="primary" class="ml-2 mt-4" @click="createQuestion"
                >Add</b-button
              ></b-col
            >
          </b-row>
          <b-form-group v-if="showQuestion">
            <div v-for="(question, index) in survey.questions" :key="index">
              <b-row>
                <b-col md="5">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="'Question ' + (index + 1)"
                  >
                    <c-input
                      inputType="text"
                      :inputId="'question-' + index"
                      :lableText="'Question ' + (index + 1) + ' *'"
                      v-model="question.text"
                    />
                    <span class="validate-error cstm-err">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="5">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="'Answer Type ' + (index + 1)"
                  >
                    <eb-select
                      :id="'answer-type-' + index"
                      v-model="question.type"
                      :options="answerTypeOptions"
                      label="label"
                      placeholder="Select Answer Type *"
                      @change="handleAnswerTypeChange(index)"
                    ></eb-select>
                    <span class="validate-error cstm-err">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="2">
                  <b-button variant="danger" @click="removeQuestion(index)"
                    >Remove</b-button
                  >
                  <b-button variant="primary" class="ml-2" @click="addQuestion(index)"
                    >Add</b-button
                  >
                </b-col>
              </b-row>
              <div v-if="['radio', 'select'].includes(question.type.value)">
                <b-form-group :label="'Options for ' + question.text">
                  <div v-for="(option, optIndex) in question.options" :key="optIndex">
                    <b-row>
                      <b-col>
                        <b-form-input
                          :id="'option-' + index + '-' + optIndex"
                          v-model="option.text"
                          placeholder="Enter Option"
                          required
                        ></b-form-input>
                      </b-col>
                      <b-col cols="auto">
                        <b-button
                          size="sm"
                          class="button-circle"
                          @click="removeOption(index, optIndex)"
                          variant="danger"
                        >
                          <i class="fa fa-trash"></i>
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                  <b-button variant="primary" @click="addOption(index)" class="mt-2"
                    >Add Option</b-button
                  >
                </b-form-group>
              </div>
              <div v-if="question.type.value === 'rating'">
                <b-row>
                  <b-col>
                    <b-form-group label="Min Rating">
                      <b-form-input
                        type="number"
                        v-model.number="question.minRating"
                        min="1"
                        max="10"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Max Rating">
                      <b-form-input
                        type="number"
                        v-model.number="question.maxRating"
                        min="1"
                        max="10"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>

              <hr />
            </div>
            <b-button variant="primary" @click="addNewQuestion">Add Question</b-button>
          </b-form-group>

          <b-row class="justify-content-center mt-4">
            <b-col cols="auto">
              <b-button variant="danger" @click="cancelSurvey">Cancel</b-button>
            </b-col>
            <b-col cols="auto">
              <b-button
                type="submit"
                variant="success"
                :disabled="
                  survey.questions.length === 0 || !survey.title || !survey.description
                "
                >Submit</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import cInput from "@/components/FormElements/CustomInput";
import ebSelect from "@/components/FormElements/Select";
import componentHeader from "@/components/componentNewHeader";

export default {
  name: "CreateSurvey",
  components: {
    cInput,
    ebSelect,
    ValidationObserver,
    ValidationProvider,
    componentHeader,
  },
  data() {
    return {
      showQuestion: false,
      survey: {
        title: "",
        description: "",
        questions: [
          {
            text: "",
            type: "",
            options: [],
            maxRating: 0,
            minRating: 0,
          },
        ],
      },
      questionId: "",
      answerTypeOptions: [
        { label: "Text", value: "text" },
        { label: "Textarea", value: "textarea" },
        { label: "Radio", value: "radio" },
        // { label: "Checkbox", value: "checkbox" },
        { label: "Select", value: "select" },
        { label: "Rating", value: "rating" },
      ],
    };
  },
  methods: {
    addNewQuestion() {
      this.survey.questions.push({
        text: "",
        type: "",
        options: [],
        maxRating: 0,
        minRating: 0,
      });
    },
    removeQuestion(index) {
      this.survey.questions.splice(index, 1);
    },
    addOption(questionIndex) {
      this.survey.questions[questionIndex].options.push({ text: "" });
    },
    removeOption(questionIndex, optionIndex) {
      this.survey.questions[questionIndex].options.splice(optionIndex, 1);
    },
    handleAnswerTypeChange(index) {
      const question = this.survey.questions[index];
      if (["radio", "select"].includes(question.type.value)) {
        question.options = [];
      } else {
        question.options = [];
      }
    },
    handleSubmit() {
      this.$router.push("/survey");
    },
    createQuestion() {
      const payload = {
        title: this.survey.title,
        description: this.survey.description,
      };
      this.$store
        .dispatch("survey/createQuestionSet", payload)
        .then((res) => {
          this.questionId = res.data._id;
          this.showQuestion = true;
          this.$toasted.show("You can create question set..", {
            type: "success",
            duration: 5000,
          });
        })
        .catch((error) => {
          this.$toasted.show("Failed to create. Please try again.", {
            type: "error",
            duration: 5000,
          });
        });
    },
    addQuestion(index) {
      const payloadData = {
        questionSet: this.questionId,
        type: ["radio", "select"].includes(this.survey.questions[index].type.value)
          ? "MCQ"
          : ["text", "textarea"].includes(this.survey.questions[index].type.value)
          ? "DESCRIPTIVE"
          : "RANGE",
        text: this.survey.questions[index].text,
        points: 1,
      };
      if (["radio", "select"].includes(this.survey.questions[index].type.value)) {
        payloadData.options = this.survey.questions[index].options.map((option) => ({
          text: option.text,
        }));
      } else if (this.survey.questions[index].type.value === "rating") {
        payloadData.range = [
          this.survey.questions[index].minRating,
          this.survey.questions[index].maxRating,
        ];
      }
      this.$store.dispatch("survey/createQuestion", payloadData);
      this.$toasted.show("Question added successfully.", {
        type: "success",
        duration: 5000,
      });
    },
    cancelSurvey() {
      this.$router.push("/survey");
    },
  },
};
</script>

<style scoped>
.card-wrap {
  margin: 20px;
}
.validate-error {
  color: red;
}
</style>
